import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { I, Portrait } from './hud';

// Nav grouped into the tactical-HUD sections from the design.
// `permission: null` => always visible.
const SECTIONS = [
  {
    label: 'Command',
    items: [
      { text: 'Dashboard', icon: I.Dashboard, path: '/dashboard', permission: null },
      { text: 'Event Planner', icon: I.Event, path: '/events', permission: null }
    ]
  },
  {
    label: 'Operations',
    items: [
      { text: 'Wallet', icon: I.Wallet, path: '/wallet', permission: 'canViewWallet' },
      { text: 'Structures', icon: I.Struct, path: '/structures', permission: 'canViewStructures' },
      { text: 'Assets', icon: I.Assets, path: '/assets', permission: 'canViewAssets' }
    ]
  },
  {
    label: 'Personnel',
    items: [
      { text: 'Members', icon: I.Members, path: '/members', permission: 'canViewMembers' },
      { text: 'Member Stats', icon: I.Stats, path: '/member-stats', permission: 'canViewMembers' }
    ]
  },
  {
    label: 'Tools',
    items: [
      { text: 'Logs', icon: I.Logs, path: '/logs', permission: 'canViewMembers' },
      { text: 'Log Visualizer', icon: I.Timeline, path: '/log-visualizer', permission: null }
    ]
  }
];

function Sidebar({ user, onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();

  const hasPermission = (perm) => !perm || user?.permissions?.[perm] === true;

  const portraitUrl = user?.characterId
    ? `https://images.evetech.net/characters/${user.characterId}/portrait?size=128`
    : null;

  const isCEO = user?.permissions?.isCEO;
  const isDirector = user?.permissions?.isDirector;
  const rank = isCEO ? 'CEO · CLEARANCE Ω' : isDirector ? 'DIRECTOR' : null;

  return (
    <aside className="sidebar">
      <div className="pilot">
        <div className="pilot-frame">
          <Portrait name={user?.characterName} size={44} src={portraitUrl} />
          <div style={{ minWidth: 0 }}>
            <div className="pilot-name">
              {user?.characterName || 'Pilot'}
              {isCEO && (
                <span style={{ color: 'var(--amber)', fontSize: 12, marginLeft: 2 }} title="CEO">★</span>
              )}
              {isDirector && !isCEO && (
                <span style={{ color: 'var(--accent)', fontSize: 12, marginLeft: 2 }} title="Director">◆</span>
              )}
            </div>
            <div className="pilot-corp">{(user?.corporationName || 'Unknown Corp').toUpperCase()}</div>
            {rank && <span className="pilot-rank">{rank}</span>}
          </div>
        </div>
      </div>

      <nav className="nav">
        {SECTIONS.map((section) => {
          const visibleItems = section.items.filter((it) => hasPermission(it.permission));
          if (visibleItems.length === 0) return null;
          return (
            <React.Fragment key={section.label}>
              <div className="nav-section">{section.label}</div>
              {visibleItems.map((it) => (
                <button
                  key={it.path}
                  type="button"
                  className={`nav-item ${location.pathname === it.path ? 'active' : ''}`}
                  onClick={() => navigate(it.path)}
                >
                  {it.icon}
                  <span>{it.text}</span>
                </button>
              ))}
            </React.Fragment>
          );
        })}
      </nav>

      <div className="sidebar-foot">
        <button type="button" className="signoff" title="Disconnect from EVEORG" onClick={onLogout}>
          {I.Logout}
          Sign Off
        </button>
      </div>
    </aside>
  );
}

export default Sidebar;
